// @flow

import type { Action } from "redux-action";
import { beginRequest, completeRequest } from "@store/utils";

import type { ApprovableContainer } from "@modules/service/types";
import type { ReferralState, Referral } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

// Get  List

export const onAddReferral = (state: ReferralState) => () => startRequest(state);
export const onAddReferralSuccess = (state: ReferralState) => () => finishRequest(state);
export const onAddReferralError = (state: ReferralState) => () => finishRequest(state);

export const onUpdateReferral = (state: ReferralState) => () => startRequest(state);
export const onUpdateReferralSuccess = (state: ReferralState) => () => finishRequest(state);
export const onUpdateReferralError = (state: ReferralState) => () => finishRequest(state);

export const onUpdateReferralAssignments = (state: ReferralState) => () => startRequest(state);
export const onUpdateReferralAssignmentsSuccess = (state: ReferralState) => () =>
  finishRequest(state);
export const onUpdateReferralAssignmentsError = (state: ReferralState) => () =>
  finishRequest(state);

export const onAddReferralAttachment = (state: ReferralState) => () => startRequest(state);
export const onAddReferralAttachmentSuccess = (state: ReferralState) => () => finishRequest(state);
export const onAddReferralAttachmentError = (state: ReferralState) => () => finishRequest(state);

export const onGetReferralList = (state: ReferralState) => () => startRequest(state);

export const onGetReferralListSuccess = (state: ReferralState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  list: payload,
});

export const onGetReferralListError = (state: ReferralState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get  Record

export const onGet = (state: ReferralState) => () => startRequest(state);

export const onGetSuccess = (state: ReferralState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  current: payload,
});

export const onGetError = (state: ReferralState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Get  Schema

export const onGetSchema = (state: ReferralState) => () => startRequest(state);

export const onGetSchemaSuccess = (state: ReferralState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  error: null,
  schema: payload,
});

export const onGetSchemaError = (state: ReferralState) => ({ payload }: Object) => ({
  ...state,
  ...finishRequest(state),
  success: false,
  error: payload,
});

// Create

export const onNew = (state: ReferralState) => (action: Action<void>) => ({
  ...state,
  draft: {},
});

export const onStartDraftSuccess = (state: ReferralState) => (
  action: Action<ApprovableContainer<Referral>>,
) => ({
  ...state,
  draft: (action.payload && action.payload.active) || {},
});

export const onSetDraft = (state: ReferralState) => ({ payload }: Object) => {
  return {
    ...state,
    draft: payload,
  };
};

export const onNewAssignments = (state: ReferralState) => (action: Action<void>) => ({
  ...state,
  assignments: [],
});

export const onSetAssignments = (state: ReferralState) => ({ payload }: Object) => ({
  ...state,
  assignments: payload,
});
